import { render, staticRenderFns } from "./DataAcuan.vue?vue&type=template&id=4a15886e&scoped=true&"
import script from "./DataAcuan.vue?vue&type=script&lang=js&"
export * from "./DataAcuan.vue?vue&type=script&lang=js&"
import style0 from "./DataAcuan.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataAcuan.vue?vue&type=style&index=1&id=4a15886e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15886e",
  null
  
)

export default component.exports